/** カード行の状態判定（一覧・バナー・フォーカスで共有） */

export type TppCardStatusFields = {
  isCheckedOut: boolean;
  isActive: boolean;
  balanceNumber: number;
};

/** 有効・未貸出・残高なし → 先にチャージが必要 */
export function isTppNeedsChargeFirst(card: TppCardStatusFields): boolean {
  return !card.isCheckedOut && card.isActive && card.balanceNumber <= 0;
}

/** いま貸出ボタンを出せる（有効・未貸出・残高あり） */
export function isTppBorrowable(card: TppCardStatusFields): boolean {
  return !card.isCheckedOut && card.isActive && card.balanceNumber > 0;
}

/**
 * チャージボタンを出すか。
 * 無効かつ未貸出・非負残高は編集で有効化してから（ノイズなチャージを隠す）。
 * 負残高や貸出中の無効は精算のため出す。
 */
export function isTppChargeActionVisible(card: TppCardStatusFields): boolean {
  if (card.isActive || card.isCheckedOut) return true;
  return card.balanceNumber < 0;
}

/** 概況「貸出可能」クリック用: 貸出できるカードを優先 */
export function pickTppFocusAvailableCard<T extends TppCardStatusFields>(
  items: T[]
): T | undefined {
  if (items.length === 0) return undefined;
  return (
    items.find((c) => isTppBorrowable(c)) ??
    items.find((c) => !c.isCheckedOut && c.isActive) ??
    items.find((c) => !c.isCheckedOut) ??
    items[0]
  );
}

/** 概況「要チャージ」クリック用: 先にチャージが必要なカード */
export function pickTppFocusNeedsChargeCard<T extends TppCardStatusFields>(
  items: T[]
): T | undefined {
  return items.find((c) => isTppNeedsChargeFirst(c));
}
